<table
  class="table tmnz-table admin-data-table sticky-header table-fixed"
  [class.trustee]="isTrustee"
>
  <thead>
    <tr class="unallocated-amounts" *ngIf="columnTotals">
      <td colspan="3"><label>Unallocated amounts</label></td>
      <td>
        {{ columnTotals.unallocatedDeposit | currency: "USD":"symbol":"1.0-0" }}
      </td>
      <td>
        {{
          columnTotals.unallocatedFlexitaxFinance
            | currency: "USD":"symbol":"1.0-0"
        }}
      </td>
      <td>
        {{
          columnTotals.unallocatedSalesRefunds
            | currency: "USD":"symbol":"1.0-0"
        }}
      </td>
      <td colspan="4">
        {{
          columnTotals.unallocatedTransfers | currency: "USD":"symbol":"1.0-0"
        }}
      </td>
    </tr>
    <tr>
      <th>
        <label class="checkbox-style">
          <input
            class="checkbox"
            type="checkbox"
            (change)="checkAll($event)"
            [checked]="allChecked()"
          />
          <span class="checkmark"></span>
        </label>
        <div *ngIf="showSelectAllPopup" class="select-all-prompt">
          <span (click)="selectOnAllPages()">Select all on ALL pages </span>
        </div>
      </th>
      <th
        *ngFor="let column of _columnsToRender"
        class="sortable {{ column.classOverride }}"
      >
        <span
          (click)="handleSort(column.key)"
          class="sortable"
          [class.sort]="sort == column.key"
          [class.up]="sortDir == 'ASC'"
          [class.down]="sortDir == 'DESC'"
        >
          {{ column.title }}
          <ng-container *ngIf="columnTotals !== null">
            <br />
            <p>
              {{
                column.key === "runDate"
                  ? "Totals"
                  : column.type === "amount"
                  ? (getColumnTotals(column.key)
                    | currency: "USD":"symbol":"1.0-0")
                  : "&nbsp;"
              }}
            </p>
            <ng-template #noTotal>
              <p>&nbsp;</p>
            </ng-template>
          </ng-container>
        </span>
      </th>
      <th>&nbsp;</th>
    </tr>
  </thead>
  <ng-container *ngIf="!loadingCheck; else loadingSort">
    <tbody *ngFor="let header of data$ | async">
      <tr
        class="has-table-child"
        tmnz-row-header
        [columnConfig]="_columnsToRender"
        [header]="header"
        [actions]="actions"
        [headersHaveItems]="headersHaveItems"
        (rowChecked)="rowChecked($event)"
      ></tr>
      <tr
        *ngIf="header.showItems"
        class="has-table-child"
        tmnz-row-child
        [runsToUncheck]="runsToUncheck"
        [columnConfig]="columnChildrenToRender"
        [header]="header"
        [withRowCheckBoxes]="withRowCheckBoxes"
        (rowChecked)="rowChecked($event)"
      ></tr>
    </tbody>
  </ng-container>

  <ng-container *ngIf="!loadingCheck">
    <tbody *ngIf="data$ | async as transactions" class="sticky-header__body">
      <tr *ngIf="!transactions.length" class="table-row-loading">
        <td [attr.colspan]="_columnsToRender.length + 2" class="text-center">
          <span>No data found</span>
        </td>
      </tr>
    </tbody>
  </ng-container>

  <ng-template #loading>
    <tbody>
      <tr class="table-row-loading">
        <td colspan="8">
          <app-dots-loader></app-dots-loader>
        </td>
      </tr>
    </tbody>
  </ng-template>
</table>

<ng-template #loadingSort>
  <tbody>
    <tr class="table-row-loading">
      <td colspan="10">
        <app-dots-loader></app-dots-loader>
      </td>
    </tr>
  </tbody>
</ng-template>
